/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters

==========================================================================================*/
import * as _ from "lodash";
export default {
	hasPermission: state => key => {
		return state.userPermissions && state.userPermissions.length > 0
			? state.userPermissions.filter(item => {
					if (item.key && key) {
						return item.key.startsWith(key.replace(".*", ""));
					} else {
						return false;
					}
			  }).length > 0 // eslint-disable-line no-mixed-spaces-and-tabs
			: false;
	},
	checkConfigDashboard: state => key => {
		if (!state.user_settings) {
			return true;
		} else {
			return _.indexOf(state.user_settings.dashboard_items, key) === -1 ? false : true;
		}
	}
};
